<!--
  Rybářské revír - doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row align-end" v-if="MapLayer_Nli_Ryby_visible">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="MapLayerLegendStaticSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>

    <v-card height="64" width="282" color="info" class="MapPnlGrdItem elevation-5">
      <v-autocomplete v-model="RybySearch_Suggest_model" class="mb-3 mx-4" :items="RybySearch_Suggest_items"
        :loading="RybySearch_Suggest_isLoading" :search-input.sync="RybySearch_Suggest_search" hide-details="true"
        hide-no-data item-text="userData.suggestFirstRow" item-value="userData.bbox"
        label="Vyhledat revír podle kódu nebo názvu" prepend-icon="mdi-map-search" clearable hide-selected return-object
        :filter="RybySearch_Filter">
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.userData.suggestFirstRow"></v-list-item-title>
            <v-list-item-subtitle v-text="item.userData.suggestSecondRow"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-card>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="VybComp = 'MapRybyInfo'">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <span class="">Informace</span>
    </v-tooltip>


    <Teleport to="#MapUserSettingsObj">

      <v-switch dense class="mt-0" v-model="MapUserSettings_WfsHoverable" color="accent"
        :label="MapUserSettings_WfsHoverable ? 'Informace o objektu se zobrazují automaticky pod kurzorem.' : 'Informace o objektu se zobrazují po kliknutí.'">
      </v-switch>

    </Teleport>

  </div>
</template>

<script>

export default {

  components: {
    Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},

    // webová služba
    ServiceMap: null,

    // Seznam  komponent
    CompList: { type: Array },
  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,


      // Vybrané prvky legendy
      VybLegList: [],

      // Viditelnost legendy
      ViewLeg: false,

      // Informace o objektu automaticky pod kurzorem nebo na kliknutí
      MapUserSettings_WfsHoverable: true,

      // Statická legenda
      StaticMapLegend: null,


      // Vybraná položka
      RybySearch_Suggest_model: null,
      // Seznam položek
      RybySearch_Suggest_items: [],
      // Načítám z webu
      RybySearch_Suggest_isLoading: false,
      // hledám
      RybySearch_Suggest_search: null,










    };
  },



  computed: {
    // Vrstva dopravy
    MapLayer_Nli_Ryby: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Ryby");
    },
    // Vrstva dopravy - viditelnost
    MapLayer_Nli_Ryby_visible: function () {
      return this.MapLayer_Nli_Ryby.layer.visible
    },

    // Podřízená vrstvy - wfs
    MapLayer_Ryby_plch_wfs: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Ryby_plch_wfs");
    },
    MapLayer_Ryby_revi_wfs: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Ryby_revi_wfs");
    },
    MapLayer_Ryby_toky_wfs: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Ryby_toky_wfs");
    },

    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },

  },

  watch: {
    // Inicializace
    IsInit: function () {
      // console.log("IsInit");
      // console.log(value);
      this.MapUserSettingsButtonView(true);
      //console.log(this.MapLayer_Nli_Ryby);

    },

    // Změna informací pod kursorem
    MapUserSettings_WfsHoverable: function (value) {
      // console.log("MapUserSettings_WfsHoverable")
      // console.log(value)

      this.MapLayer_Ryby_plch_wfs.layer.hoverable = value;
      this.MapLayer_Ryby_plch_wfs.layer.selectable = !value;

      this.MapLayer_Ryby_revi_wfs.layer.hoverable = value;
      this.MapLayer_Ryby_revi_wfs.layer.selectable = !value;

      this.MapLayer_Ryby_toky_wfs.layer.hoverable = value;
      this.MapLayer_Ryby_toky_wfs.layer.selectable = !value;

    },


    // Hledat výraz - suggest
    RybySearch_Suggest_search(value) {
      // if (value.length > 2) {
      this.RybySearch_Suggest_isLoading = true;

      this.ServiceMap.SuggestRyby(value)
        .then((response) => {
          if (response.data.Navrh == null) {
            this.RybySearch_Suggest_items = [];
            this.RybySearch_Suggest_isLoading = false;
          } else {
            this.RybySearch_Suggest_items = response.data.Navrh;
            this.RybySearch_Suggest_isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.RybySearch_Suggest_items = [];
          this.RybySearch_Suggest_isLoading = false;
        })
        .then(function () {
          // always executed
        });
      // }
    },

    // Výběr položky - find a zoom
    RybySearch_Suggest_model(value) {
      if (value !== null && typeof value !== "undefined") {
        // console.log("MapSearch_Suggest_model");
        // console.log(value);

        this.MapViewZoomToMbr({
          epsg: "EPSG:5514",
          xmin: value.userData.bbox.Xmin,
          ymin: value.userData.bbox.Ymin,
          xmax: value.userData.bbox.Xmax,
          ymax: value.userData.bbox.Ymax,
        })


      }
    },





  },

  methods: {

    // Viditelnost tlačítka pro dialog s nastavením
    MapUserSettingsButtonView: function (value) {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapUserSettingsButtonView', value);
    },


    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function () {
      this.$emit('MapLayerLegendStaticSet', this.MapLayer_Nli_Ryby.id, this.MapLayer_Nli_Ryby.legend.title, this.StaticMapLegend);
    },


    // Načtení statické legendy
    NactiStaticMapLegend: function () {
      this.ServiceMap.MapLegend(this.MapLayer_Nli_Ryby.legend.staticLegName)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.StaticMapLegend = response.data.Vypis;
          } else {
            return null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },

    // Filtrování položek
    RybySearch_Filter: function (item, queryText, itemText) {
      // výchozí je následující funkce
      itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      // Jenže pak se nezobrazí položky, které mají jiný text
      // např. když pošlu na vyhledávač Mapy.cz
      // '50.2233361N 14.8512964E' vyhledá se '50°13'24.01"N 14°51'4.667"E
      // jenže ten se pak přes tento filtr nedostane, má jiný text
      // pro vyhledávání na MapyCz nás vlastně tento filtr nezajímá, chceme zobrazit vše, co jejich fukce vrátí
      // Uvedené platilo pro MapyCz, ale i pro CUZK se prostě zobrazí vše, co se vrátí, nic se nefiltruje.
      return true;
    },

    // Změna mapového výřezu podle obdelníku
    MapViewZoomToMbr: function (value) {
      this.$emit('MapViewZoomToMbr', value);
    },

  },

  mounted() {
    // První spuštění nástroje
    //console.log("Ryby start");

    // Načtení legendy
    this.NactiStaticMapLegend()

    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })



  },
};
</script>